<template>
  <PlanSelectionCard
    :title="foundationCardTitle"
    :basic-card="!isFoundationGold"
    :features="foundationCardData"
    :theme="theme"
    :read-only="true"
  />
</template>

<script>
import PlanSelectionCard from '@/components/common/cards/PlanSelectionCard'

export default {
  name: 'PlanSelectionCardReadOnly',

  components: {
    PlanSelectionCard
  },

  props: {
    theme: {
      type: String,
      default: ''
    }
  },

  computed: {
    isBloomFlow () {
      return this.$store.state.foundation.isBloomFlow
    },

    foundationCardData () {
      let goldAmount = '$66 bi-weekly*'
      let basicAmount = '$37 bi-weekly*'
      if (this.isBloomFlow) {
        goldAmount = '$71 bi-weekly*'
        basicAmount = '$37 bi-weekly*'
      }

      return [
        {
          text: this.isFoundationGold ? goldAmount : basicAmount,
          checked: true
        },
        {
          text: 'Payments reported to credit bureaus',
          checked: true
        },
        {
          text: 'Free credit score',
          checked: true
        },
        {
          text: 'Cancel any time with no fees',
          checked: true
        },
        {
          text: '$750 saved after 12 months',
          checked: this.isFoundationGold
        },
        {
          text: 'Access savings at any time',
          checked: this.isFoundationGold
        },
        {
          text: 'Guaranteed loan offer after 12 months and saving $750',
          checked: this.isFoundationGold
        },
        {
          text: 'Bloom Budgeting App',
          checked: this.isFoundationGold,
          bloomOnly: true
        },
        {
          text: 'Rent Reporting',
          checked: this.isFoundationGold,
          bloomOnly: true
        }
      ]
    },

    foundationCardTitle () {
      return this.isFoundationGold ? 'The Foundation Gold' : 'The Foundation Basic'
    },

    isFoundationGold () {
      return this.$store.state.foundation.isFoundationGold
    }
  }

}
</script>

<style scoped lang="scss">
</style>
